import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import { useEffect, useState } from "react";
import { createUseStyles, useTheme } from "react-jss";
import Cancel from "../../assets/images/cancel.svg";

const useStyles = createUseStyles({
  container: {
    height: 48,
    backgroundColor: "#F4F6F8",
    borderRadius: 20,
    padding: 8,
    display: "flex",
    alignItems: "center",
    gap: 7,
  },
  confirm: {
    width: 77,
    height: 28,
    backgroundColor: "#0054FF",
    borderRadius: 100,
    color: "white",
    border: "none",
    padding: "2px 24px",
    fontSize: 14,
    "&:disabled": {
      backgroundColor: "#D5D7D9",
      color: "#B0B2B6",
    },
  },
  cansel: {
    width: 32,
    height: 32,
    cursor: "pointer",
  },
  state: {
    width: 32,
    height: 32,
    flex: 1,
    backgroundColor: "white",
    borderRadius: 2000,
    padding: "4px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  text: {
    fontSize: 14,
    color: "#9C9FA4",
  },
  "@media screen and (min-width: 688px) ": {
    container: {
      height: 58,
    },
    cansel: {
      width: 40,
      height: 40,
    },
    state: {
      width: 40,
      height: 40,
    },
    confirm: {
      width: 147,
      height: 38,
    },
    text: {
      fontSize: 16,
    },
  },
});

const ASRProcess = ({
  isLoading,
  mutateAsrDecode,
  setIsRecording,
  resetTimer,
  Mp3Recorder,
  seconds,
  minutes,
  setText,
}) => {
  const [currentState, setCurrentState] = useState("درحال گوش دادن");
  const theme = useTheme();
  const styles = useStyles({ theme });

  const stop = () => {
    resetTimer();
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const file = new File(buffer, "question.mp3", {
          type: blob.type,
          lastModified: Date.now(),
        });
        let formData = new FormData();
        formData.append("speech", file);
        setIsRecording(false);
        if (blob.size > 1500) {
          mutateAsrDecode(formData);
        }
      })
      .catch((e) => console.log(e));
  };

  const cancel = () => {
    Mp3Recorder.stop();
    resetTimer();
    setIsRecording(false);
  };

  useEffect(() => {
    if (isLoading) setCurrentState("درحال پردازش");
    else setCurrentState("درحال گوش دادن");
  }, [isLoading]);

  return (
    <div className={styles.container}>
      <img
        alt="cancel"
        src={Cancel}
        onClick={cancel}
        className={styles.cansel}
      />
      <div className={styles.state}>
        {!isLoading ? (
          <>
            <span>
              {digitsEnToFa(minutes).toString()}:
              {digitsEnToFa(seconds)
                .toString()
                .padStart(2, "۰")}
            </span>
          </>
        ) : (
          <FontAwesomeIcon icon={faSpinner} pulse color="gray" size="lg" />
        )}
        <span className={styles.text}>{currentState}</span>
      </div>
      <button onClick={stop} className={styles.confirm} disabled={isLoading}>
        تایید
      </button>
    </div>
  );
};

export default ASRProcess;
